module.exports = __webpack_public_path__ + "static/media/Soybean1VE.f0f0f4cd.PNG";